import { Module } from 'vuex';

import { ShiftCMSState } from '@/store';
import { DataTable, DataTableLegend } from '@/models/data-table.model';
import dataTablesService from '@/services/data-tables.service';

export interface DataTablesState {
  dataTables: DataTable[];
  defaults: DataTable[];
  legends: DataTableLegend[];
}

export enum DataTablesMutations {
  SetDataTables = 'ds/SetDataTables',
  SetDataTablesDefaults = 'ds/SetDataTablesDefaults',
  SetDataTablesLegends = 'ds/SetDataTablesLegends',
}

export enum DataTablesActions {
  GetDataTables = 'ds/GetDataTables',
  GetDataTablesDefaults = 'ds/GetDataTablesDefaults',
  GetDataTablesLegends = 'ds/GetDataTablesLegends',
  AddDataTable = 'ds/AddDataTable',
  UpdateDataTable = 'ds/UpdateDataTable',
  DeleteDataTable = 'ds/DeleteDataTable',
}

const sn = (str: DataTablesActions | DataTablesMutations): string =>
  str.replace(/ds\//g, '');

export const dataTablesStore: Module<DataTablesState, ShiftCMSState> = {
  namespaced: true,
  state: {
    dataTables: [],
    defaults: [],
    legends: [],
  },
  mutations: {
    [sn(DataTablesMutations.SetDataTables)](state, dataTables: DataTable[]) {
      state.dataTables = dataTables;
    },
    [sn(DataTablesMutations.SetDataTablesDefaults)](
      state,
      defaults: DataTable[],
    ) {
      state.defaults = defaults;
    },
    [sn(DataTablesMutations.SetDataTablesLegends)](
      state,
      legends: DataTableLegend[],
    ) {
      state.legends = legends;
    },
  },
  actions: {
    async [sn(DataTablesActions.GetDataTables)]({ commit }) {
      const res = await dataTablesService.getList();
      if (res.status) {
        commit(sn(DataTablesMutations.SetDataTables), res.data);
      }
    },
    async [sn(DataTablesActions.GetDataTablesDefaults)]({ commit }) {
      const res = await dataTablesService.getDefaults();
      if (res.status) {
        commit(sn(DataTablesMutations.SetDataTablesDefaults), res.data);
      }
    },
    async [sn(DataTablesActions.GetDataTablesLegends)]({ commit }) {
      const res = await dataTablesService.getLegends();
      if (res.status) {
        commit(sn(DataTablesMutations.SetDataTablesLegends), res.data);
      }
    },
    async [sn(DataTablesActions.AddDataTable)](_, label: DataTable) {
      const res = await dataTablesService.create({
        ...label,
        id: undefined,
      });

      return res.status;
    },
    async [sn(DataTablesActions.UpdateDataTable)](_, label: DataTable) {
      const res = await dataTablesService.edit(label);

      return res.status;
    },
    async [sn(DataTablesActions.DeleteDataTable)]({ dispatch }, id: number) {
      const res = await dataTablesService.delete(id);

      if (res.status) {
        dispatch(sn(DataTablesActions.GetDataTables));
      }
    },
  },
};
